import { useState } from 'react'
import { Grid, Image } from 'semantic-ui-react'
import { useNavigate } from 'react-router-dom'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { IconButton, Card, Text, Button } from '@/base'
import { Colors } from '@/src/styles/theme'
import { useAnalyticsTrack } from '@/featuresV1/Amplitude'

const config = {
  taxDeductions: {
    key: 'NEW_ON_HOMEPAGE_BANNER_KEY_MAXIMIZE_TAX_DEDUCTIONS',
    image: 'https://heard-images.s3.amazonaws.com/assets/home-sparkles.svg',
    title: 'What’s new on the Home page',
    description: (
      <>
        Check out <b>Maximize Tax Deductions</b>, which tracks your year-to-date
        tax savings from business expense deductions and offers tips on how to
        lower your tax liability. Stay tuned for upcoming enhancements featuring
        more personalized insights and reporting.
      </>
    ),
    link: null,
  },
  mtdGoals: {
    key: 'NEW_ON_HOMEPAGE_BANNER_KEY_MTD_GOALS',
    image: 'https://heard-images.s3.amazonaws.com/assets/chart-sparkles.svg',
    title: 'Practice Goal Setting and Real Time Income Tracking',
    description: (
      <>
        Set goals for practice income, expenses, and profit with personalized
        guidance to help your practice succeed. Plus, track your practice&apos;s
        monthly income in real-time and compare performance to previous months
        (based on available historical data).
        <br />
        <br />
        Practice Insights can now be found under the &quot;Insights&quot; menu
        on the left.
      </>
    ),
    link: '/goal-setting',
  },
}

const NewOnHomepageBanner = ({ feature }: { feature: keyof typeof config }) => {
  const navigate = useNavigate()
  const { key, image, title, description, link } = config[feature]

  const track = useAnalyticsTrack()
  const [noticeDismissed, setNoticeDismissed] = useState(
    localStorage.getItem(key) === 'true'
  )

  if (noticeDismissed) {
    return null
  }

  return (
    <Card
      type="subsection"
      backgroundColor="natural"
      style={{ marginBottom: 40 }}
    >
      <IconButton
        icon={regular('x')}
        color="darkGray"
        style={{ position: 'absolute', right: 16, top: 16, zIndex: 1000 }}
        onClick={() => {
          track("clicked dismiss what's new banner")
          localStorage.setItem(key, 'true')
          setNoticeDismissed(true)
        }}
      />
      <Grid>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            <div
              style={{
                backgroundColor: Colors.champagne,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Image
                src={image}
                style={{
                  width: 160,
                  height: 95,
                  backgroundColor: 'transparent',
                  padding: 5,
                }}
              />
            </div>
          </Grid.Column>
          <Grid.Column width={link ? 10 : 13}>
            <Text as="h3">{title}</Text>
            <br />
            <Text>{description}</Text>
          </Grid.Column>
          {link && (
            <Grid.Column width={3} verticalAlign="middle">
              <Button
                onClick={() => {
                  track('Clicked Get Started Goal Setting CTA')
                  navigate(link)
                }}
                variant="secondary"
              >
                Get Started
              </Button>
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </Card>
  )
}

export default NewOnHomepageBanner
